import React, { useEffect, useRef, useState } from 'react'
import { HistoryTimerIcon, HistoryCheckIcon, DeliveredIcon, HistoryExclamatoryIcon, MessageSeenIcon } from '../../icon'
import { ChannelDeliveryStatus, WidgetTitle } from '../../models/channels/channels.model'
import { Contact, MediaModel } from '../../models/conversations'
import { UtilityService } from '../../services/UtilityService'
import { AutomationRulesLabel } from '../shared/constants'
import MediaContainer from '../shared/media/media.container'
import { useSelector } from 'react-redux'
import { UserModel } from '../../models/users.model'
import * as selector from '../../selectors/selectors'
import { Tooltip } from '@mui/material'
import { MessageType } from '../../models/media.models'
import Avatar from '../shared/avatar.component'


interface IProps {
    MessageData: any;
    OpenForwardMessage: (media: MediaModel, msg: string) => void;
    ChannelType?: number;
    UserName?: string;
    ProfilePicLink?: string
    TemplateMessage?: any;
    IsWidget?: boolean;
    IsMobile?: boolean;
    BackgroundColor?: string;
    WidgetType?: number;
    Icon?: string;
    IsExpanded?: boolean;
}

const LiveChatDisplayConversation: React.FC<IProps> = (Props: IProps) => {

    const wrapperRef = useRef<HTMLDivElement>(null);

    const { IsOutbound, FromPhoneNumber, MessageDateTime, SenderID } = Props.MessageData;
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const AllUsers: UserModel[] = useSelector(selector.allUsers);
    const Contacts: Contact[] = useSelector(selector.contacts);
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsExpanded(true);
        }, 1);
    }, []);


    const getUserName = (senderId: string) => {
        let data = AllUsers.find((x) => x.ID === senderId);
        if (data) {
            let name = data.FirstName + " " + data.LastName.charAt(0).toUpperCase() + data.LastName.slice(1).toLowerCase();
            return UtilityService.trimMessage(name, 20)
        }
        else if (senderId === AutomationRulesLabel.SENDERID) {
            return AutomationRulesLabel.AUTOMATED_REPLY
        }
    }

    const getGroupChatUserName = (number: string) => {
        var data = Contacts.find((x) => x.PhoneNumber === number);
        if (!!data) {
            let name = data?.Name;
            return UtilityService.trimMessage(name, 17)
        }
        else if (data === undefined) {
            return UtilityService.maskPhoneNumberOnLength(number)
        }
    }

    return (
        <div className={`animate ${isExpanded ? "expanded" : ""}`}>
            {Props.MessageData.MessageType === "UPDATE" ?
                <div className='w-p-100 h-6 d-flex justify-center align-center'>
                    <div className="update-bottom w-p-10">
                    </div>
                    <div className=' color-primary-accent r-h6-medium mx-1'>
                        {Props.MessageData.Message}
                    </div>
                    <div className="update-bottom w-p-10">
                    </div>
                </div>
                : <>
                    <div className={`d-flex w-p-100 ${IsOutbound ? "justify-flex-end" : ""}`}>
                        <div className='d-flex align-end'>
                            {!IsOutbound && Props.WidgetType === WidgetTitle.NAME_AND_LOGO && <Avatar className={` ${Props.IsMobile ? "w-2 h-2" : ""}  br-5 ml-2 mr-1 mb-1 r-h5-bold`} Name={Props.UserName} ImgSrc={!!Props.Icon ? Props.Icon : ""} Size={24} />}
                            <div className={`${(Props.MessageData.MessageType === MessageType.TEXT || Props.MessageData.MessageType === MessageType.FILE) ? "p-1" : ""} my-1 r-h5-regular ${IsOutbound ? `live-chat-outboundmsg color-secondary mr-2 mx-auto` : " live-chat-inboundmsg bg-color-secondary"}  ${isExpanded ? 'expanded' : ''} ${(Props.IsWidget) ? "" : "share-chat-msg-max-width"} ${!IsOutbound && Props.WidgetType === WidgetTitle.NAME_AND_LOGO ? "" : "ml-2"}`} style={{ background: Props.BackgroundColor }}>
                                <div ref={wrapperRef}>
                                    <MediaContainer IsMobile={Props.IsMobile} Mediatype={Props.MessageData.MessageType} Value={Props.MessageData.Message} Channel={Props.ChannelType} IsWidget={true} InBound={IsOutbound} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex align-center ${IsOutbound ? "justify-flex-end pr-2" : Props.IsMobile ? "ml-7" : "ml-6"} `}>
                        <div>
                            {IsOutbound ?
                                (Props.MessageData.DeliveryStatus === ChannelDeliveryStatus.SENDING ?
                                    <Tooltip title='Sending' placement='bottom'>
                                        <HistoryTimerIcon className="mr-1" />
                                    </Tooltip>
                                    : Props.MessageData.DeliveryStatus === ChannelDeliveryStatus.SENT ?
                                        <Tooltip title='Sent' placement='bottom'>
                                            <HistoryCheckIcon className="mr-1" />
                                        </Tooltip>
                                        : Props.MessageData.DeliveryStatus === ChannelDeliveryStatus.SENT_FAILED ?
                                            <Tooltip title='Failed' placement='bottom'>
                                                <HistoryExclamatoryIcon className="mr-1" />
                                            </Tooltip>
                                            : Props.MessageData.DeliveryStatus === ChannelDeliveryStatus.DELIVERED ?
                                                <Tooltip title='Delivered' placement='bottom'>
                                                    <DeliveredIcon className="mr-1" />
                                                </Tooltip>
                                                : Props.MessageData.DeliveryStatus === ChannelDeliveryStatus.READ ?
                                                    <Tooltip title={`Seen`} placement='bottom'>
                                                        <MessageSeenIcon className="mr-1" />
                                                    </Tooltip>
                                                    : <></>
                                )
                                :
                                <span className='mr-1'></span>
                            }
                        </div>
                        <div className={`color-conv-hist-date-day  ${Props.IsMobile ? "live-chat-footer" : "r-footnote"} ${IsOutbound ? "  d-flex justify-between" : ""}`}>
                            <span>{IsOutbound ? getUserName(SenderID || Props.MessageData?.SenderID) : getGroupChatUserName(FromPhoneNumber)}</span>
                            <span>{UtilityService.convertToTimeFormat(MessageDateTime || Props.MessageData.CreatedAt?.replace(" +0000 UTC", "Z"))}</span>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default LiveChatDisplayConversation;
